function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "percentage-filled",
  transform: "translate(0)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_11833",
  "data-name": "Path 11833",
  d: "M9.736,14.973a5.236,5.236,0,1,1,5.236-5.236,5.236,5.236,0,0,1-5.236,5.236Z",
  transform: "translate(-4.5 -4.5)",
  fill: "#ac1ede"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_11834",
  "data-name": "Path 11834",
  d: "M4.5,28.154,28.153,4.5l1.482,1.482L5.981,29.635Z",
  transform: "translate(-4.5 -4.5)",
  fill: "#ac1ede"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_11835",
  "data-name": "Path 11835",
  d: "M25.486,30.723a5.236,5.236,0,1,1,5.236-5.236A5.236,5.236,0,0,1,25.486,30.723Z",
  transform: "translate(-5.588 -5.588)",
  fill: "#ac1ede"
}));

var SvgPercentageFilled = function SvgPercentageFilled(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25.135,
    height: 25.135,
    viewBox: "0 0 25.135 25.135",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPercentageFilled, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/percentage-filled.e8a530c2.svg";
export { ForwardRef as ReactComponent };